import { aiAboutCardModule, essityAiModelCardModule } from './modules';

export const aiModelsPlugin = [aiAboutCardModule, essityAiModelCardModule];
